'use strict';

/**
 * Shared IntersectionObserver options for PLP enter animations
 * (product tiles .animate-up and marketing slots .pd-animate-up).
 * Keep these identical so side-by-side items start together.
 */
module.exports = {
    rootMargin: '100px 0px',
    threshold: 0.01
};
